import * as React from 'react';
import * as ReactDom from 'react-dom';

import { useContext, useReducer, useState, useEffect } from "react";
import { MessagesContext } from "../common/context";
import { messagesReducer } from "../common/reducer";

//import { graph } from '@pnp/graph';
//import { MSGraphClient } from '@microsoft/sp-http';
//import { WebPartContext } from "@microsoft/sp-webpart-base";

import { useErrorBoundary } from "use-error-boundary";
import log from 'loglevel';

import { escape } from '@microsoft/sp-lodash-subset';
import * as Fabric from 'office-ui-fabric-react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { CommandBar, ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';

import  { Chat } from './Chat';
import  * as uuidv4 from "uuid/v4";

import { getAuthenticatedClient } from "../../auth/authClient";
var graph = require('@microsoft/microsoft-graph-client');


/**
 * 
 * @param {
 * } param0 
 */
export  function ChatsContainer({ accessToken }) {

  const { state , dispatch } = useContext(MessagesContext);  
  const [chats, setChats] = useState(null);
  const [reloadChats, setReloadChats] = useState(true);  
  const { ErrorBoundary, didCatch, error, errorInfo } = useErrorBoundary();
               
  log.info(`@ChatsContainer`);

   React.useEffect(() => {  
    log.info(` useEffect  @ ChatsContainer`);
      if (reloadChats) {   
            getChats(accessToken);
            setReloadChats(false)                   
      } 
  }, [reloadChats]);

  const handleReloadChats = ()=>{
    log.info(` handleReloadChats  @ ChatsContainer`)
    setReloadChats(true);
  };

 
  const getChats = async ( accessToken ) =>{
    log.info(`getChats @ ChatsContainer}`);
    log.debug(`@getChats ACCESSTOKEN: ${accessToken}`);
    
    const chatsUrl = `/me/chats`;
    const client = getAuthenticatedClient(accessToken);
    
    const res = await client.api(chatsUrl)
          .headers({
            "Content-Type" : "application/json;charset=UTF-8"
          })
          .version('beta')
          .get().then((response) => {
            
                const  selectedChats =   response.value.map(chat => {
                  
                  const _chat = 
                    {
                        id :  chat.id,
                        //webUrl : chat.webUrl,
                        displayName : chat.topic == null ? `No Topic. Last updated: ${chat.lastUpdatedDateTime}` : chat.topic,//chat.displayName
                        createdDateTime : chat.createdDateTime,
                        lastUpdatedDateTime : chat.lastUpdatedDateTime
                    };
                    return _chat;
                });                
                setChats(selectedChats); 
          }
        )  
  };

  const _items = [
    {
      key: 'refresh',
      text: 'Refresh',
      iconProps: { iconName: 'Share' },
      onClick: () => {handleReloadChats()}
    },
    {
      key: 'note',
      text: ' Dynamic Explorer of Chats and Messages:',
      disabled: true
    }
  ];
      
  const renderCommandBar=()=>{
    log.info(`renderCommandBar @ TeamsContainer}`);
    return (
            <CommandBar
                    items={_items}
                  />
            );  
  };
  
  const lineStyle = () => {
    const _style =
       {
            height: "1px",
            backgroundColor: "white",
        };
    return _style;
  };

  const notFoundStyle = () => {
    const _style =
       {
            color: 'grey',
            marginLeft: '100px',

        };
    return _style;
  };

  const MyErrorComponent = ({error})=>{
    log.error(`error @ ChatsContainer: ${error.message}  `);
    return (
    <div key={uuidv4()}>error</div>
    )
  }

  const renderChats = ( accessToken )=>{

    log.info(`renderChats @ ChatsContainer}`);

    // if (accessToken === undefined || accessToken =='') {
  //   return (
  //     <>  
  //     <div style={lineStyle()} />     
  //     <div>
  //         Please refresh to load Teams list 
  //     </div>
  //     </> 
  //   )
  // }

  if (chats == null || chats == undefined){
    return (
      <>  
      <div style={lineStyle()} /> 
      <Spinner size={SpinnerSize.large} />
      </> 
    )
    } else if ( chats.length < 1)
    {
      return (
      <>  
      <div style={lineStyle()} /> 
      <div style={notFoundStyle()}> The logged in user account is not a member of any Chat.</div>
      </> 
      )
    }    

  const  _chatsList = chats.map(chat => {      
              return(
                <ErrorBoundary  key={uuidv4()}
                render={() => 

                    <Chat
                      key={uuidv4()}
                      chatId = {chat.id}
                      chat = {chat}
                      accessToken = { accessToken }
                    />
                }
                renderError={({ error, errorInfo }) => <MyErrorComponent error={error} />}                             
                >
                </ErrorBoundary>              
                        
              ) ;             
            }
          )      
    return (
      <>  
          <div style={lineStyle()} />     
          {_chatsList}
      </> 
    )
  };

  return (
  <>
        {renderCommandBar()}
        {renderChats( accessToken )}
  </>
  );
}

